/*** IMPORTS FROM imports-loader ***/
var define = false;

import cssVars from 'css-vars-ponyfill';

export default () => {
  cssVars();
};

